export default __webpack_public_path__ + "static/media/University_of_Bath_logo.c2f9f4d1.png";